import request from '@/api/request'

/**
 * 登录
 */
export function loginApi (data) {
  return request({
    url: '/verify/login',
    method: 'post',
    data
  })
}

/**
 * 获取用户信息
 */
export function userInfoApi () {
  return request({
    url: '/verify/user_info',
    method: 'get'
  })
}

/**
 * 校验用户是否注册
 */
export function checkUserApi (data) {
  return request({
    url: '/verify/check_user',
    method: 'post',
    data
  })
}

/**
 * 校验移动端手机验证码
 */
export function checkCodeApi (data) {
  return request({
    url: '/verify/check_code',
    method: 'post',
    data
  })
}

/**
 * 注册
 */
export function registerApi (data) {
  return request({
    url: '/verify/register',
    method: 'post',
    data
  })
}

/**
 * 重置密码
 */
export function resetPwdApi (data) {
  return request({
    url: '/verify/reset_pwd',
    method: 'post',
    data
  })
}

/**
 * 同意协议
 */
export function goAgreeApi (data) {
  return request({
    url: '/verify/agreeProtocol',
    method: 'post',
    data
  })
}

// ==================== 图形点选验证码 ====================

/**
 * 生成图形点选验证码
 * @returns {Promise} 验证码数据（captchaId、image、hintIcon、targetCount）
 */
export function generateCaptchaApi () {
  return request({
    url: '/captcha/generate',
    method: 'get'
  })
}

/**
 * 校验验证码（仅校验，登录用）
 * @param {Object} data - { captchaId, clicks: [{x, y}] }
 * @returns {Promise} 校验结果，成功时包含 verifyToken
 */
export function verifyCaptchaApi (data) {
  return request({
    url: '/captcha/verify',
    method: 'post',
    data
  })
}

/**
 * 校验验证码 + 扩展处理（注册/忘记密码/改密码用）
 * @param {Object} data - { captchaId, clicks: [{x, y}], mobile }
 * @returns {Promise} 校验结果，成功时包含 verifyToken 且已发送短信
 */
export function verifyCaptchaExtApi (data) {
  return request({
    url: '/captcha/verify_ext',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/user/index.js